import { render, staticRenderFns } from "./CompanionOptionsUpsell.vue?vue&type=template&id=ee31a5a6&"
import script from "./CompanionOptionsUpsell.vue?vue&type=script&lang=js&"
export * from "./CompanionOptionsUpsell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports